(function () {
  'use strict';

  var config = window.BaviTheme || {};
  var loaded = { clarity: false, klaviyo: false };
  var synced = {};
  var pendingState = { analytics: false, marketing: false };
  var deferredLoadStarted = false;

  function scriptsContain(pattern) {
    return Array.prototype.some.call(document.scripts, function (script) {
      return pattern.test(script.src || '') || script.getAttribute('data-bavi-loader') === pattern.source;
    });
  }

  function hasKlaviyo() {
    return typeof window.klaviyo !== 'undefined' || typeof window._learnq !== 'undefined' || scriptsContain(/klaviyo\.com|klaviyo\.js/i);
  }

  function appendScript(src, marker) {
    return new Promise(function (resolve) {
      var existing = document.querySelector('script[data-bavi-loader="' + marker + '"]');
      if (existing) { resolve(true); return; }
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-bavi-loader', marker);
      script.onload = function () { resolve(true); };
      script.onerror = function () { resolve(false); };
      (document.head || document.documentElement).appendChild(script);
    });
  }

  function loadKlaviyo() {
    if (loaded.klaviyo || hasKlaviyo() || !config.klaviyoPublicKey) return Promise.resolve(true);
    loaded.klaviyo = true;
    window._learnq = window._learnq || [];
    return appendScript('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(config.klaviyoPublicKey), 'klaviyo');
  }

  /* Clarity is loaded once, after the first render, through the theme. The
     official app embed is disabled for this theme so the tag cannot be
     inserted twice. Keeping this independent from consent callbacks also
     preserves session visibility when the privacy API is not ready yet. */
  function loadClarity() {
    if (loaded.clarity || !config.clarityProjectId || document.querySelector('script[src*="clarity.ms/tag/"]')) return Promise.resolve(true);
    loaded.clarity = true;
    return appendScript('https://www.clarity.ms/tag/' + encodeURIComponent(config.clarityProjectId), 'clarity');
  }

  function scheduleClarity() {
    var start = function () {
      var idle = window.requestIdleCallback || function (callback) { window.setTimeout(callback, 350); };
      idle(function () { window.setTimeout(loadClarity, 900); }, { timeout: 1800 });
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }

  function getStoredAttribution() {
    try { return JSON.parse(window.sessionStorage.getItem('bavi_attribution') || '{}'); } catch (error) { return {}; }
  }

  function syncAttribution(state) {
    if (!state.analytics && !state.marketing) return;
    var stored = getStoredAttribution();
    var allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid', 'dclid', 'srsltid', 'yclid', 'twclid', 'li_fat_id', 'epik', 'irclickid', 'referrer', 'landing_page', 'first_seen_at'];
    if (state.marketing) allowed = allowed.concat(['fbclid', '_fbp', '_fbc']);
    var attributes = {};
    allowed.forEach(function (key) { if (stored[key]) attributes[key] = String(stored[key]).slice(0, 500); });
    if (!Object.keys(attributes).length) return;
    var signature = JSON.stringify(attributes);
    var consentKey = state.marketing ? 'marketing' : 'analytics';
    if (synced[consentKey] === signature) return;
    synced[consentKey] = signature;
    fetch((config.cartUpdateUrl || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true
    }).catch(function () {});
  }

  function readConsent(detail) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (detail && (typeof detail.analyticsAllowed === 'boolean' || typeof detail.marketingAllowed === 'boolean')) {
      return { analytics: detail.analyticsAllowed === true, marketing: detail.marketingAllowed === true };
    }
    if (!privacy) return null;
    try {
      return {
        analytics: typeof privacy.analyticsProcessingAllowed === 'function' ? privacy.analyticsProcessingAllowed() : false,
        marketing: typeof privacy.marketingAllowed === 'function' ? privacy.marketingAllowed() : false
      };
    } catch (error) { return null; }
  }

  function schedule(state) {
    if (!state || (!state.analytics && !state.marketing)) return;
    pendingState.analytics = pendingState.analytics || state.analytics;
    pendingState.marketing = pendingState.marketing || state.marketing;
    syncAttribution(state);
    var startDeferredLoad = function () {
      window.setTimeout(function () {
        if (pendingState.marketing) loadKlaviyo();
      }, 700);
    };
    if (deferredLoadStarted) {
      if (document.readyState === 'complete') startDeferredLoad();
      return;
    }
    deferredLoadStarted = true;
    if (document.readyState === 'complete') startDeferredLoad();
    else window.addEventListener('load', startDeferredLoad, { once: true });
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event.detail || {};
    if (detail.customerPrivacy) detail = detail.customerPrivacy;
    schedule(readConsent(detail));
  });

  function boot(attempt) {
    var state = readConsent();
    if (state) { schedule(state); return; }
    if ((attempt || 0) < 20) window.setTimeout(function () { boot((attempt || 0) + 1); }, 250);
  }

  scheduleClarity();
  var start = function () { boot(0); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
